// TO DEFINE THE STATES AND CHANGE STATUS
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAvailabilityEvents,
  fetchAvailabilityEvent,
  createAvailabilityEventThunk,
  updateAvailabilityEventThunk,
  deleteAvailabilityEventThunk,
} from './availabilityThunks';
import { AVAILABILITY_STATUS } from '../../utils/constants/availability.constants';

const initialState = {
  events: [],
  selectedEvent: null,
  status: 'idle',
  error: null,
};

const availabilitySlice = createSlice({
  name: 'availability',
  initialState,
  reducers: {
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
    clearSelectedEvent: (state) => {
      state.selectedEvent = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Events for this user
      .addCase(fetchAvailabilityEvents.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAvailabilityEvents.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.events = action.payload;
      })
      .addCase(fetchAvailabilityEvents.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Fetch Single Event
      .addCase(fetchAvailabilityEvent.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAvailabilityEvent.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedEvent = action.payload;
      })
      .addCase(fetchAvailabilityEvent.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Create Event
      .addCase(createAvailabilityEventThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createAvailabilityEventThunk.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.events.push(action.payload);
        state.selectedEvent = action.payload;
      })
      .addCase(createAvailabilityEventThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Update Event
      .addCase(updateAvailabilityEventThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateAvailabilityEventThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateAvailabilityEventThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Delete Event
      .addCase(deleteAvailabilityEventThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteAvailabilityEventThunk.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Update the event status to 'deleted' in the state
        const eventIndex = state.events.findIndex((event) => event.id === action.payload);
        if (eventIndex !== -1) {
          state.events[eventIndex].status = AVAILABILITY_STATUS.DELETED;
        }
      })
      .addCase(deleteAvailabilityEventThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setSelectedEvent, clearSelectedEvent } = availabilitySlice.actions;

export const selectAllEvents = (state) =>
  state.availability.events.filter((event) => event.status !== AVAILABILITY_STATUS.DELETED);
export const selectSelectedEvent = (state) => state.availability.selectedEvent;
export const selectAvailabilityStatus = (state) => state.availability.status;
export const selectAvailabilityError = (state) => state.availability.error;

export default availabilitySlice.reducer;
